import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';

import '../../app/common/MediaQuery/responsive-tables.css';
import UnauthorizedMessage from '../UnauthorizedMessage';
import LoadingComponent from '../../app/layout/LoadingComponent';
import DynamicTableFrontEnd from '../DynamicTable/DynamicTableFrontEnd';

const VaultMasterTable = () => {
  const { customerStore, dashboardStore, userStore } = useStore();
  const { loadCustomers, customerRegistery, customeritemsByDate } =
    customerStore;
  const [showText, setShow] = useState(false);

  // to load all existing vaults
  useEffect(() => {
    if (customerRegistery.size <= 1) loadCustomers();
  }, [customerRegistery.size, loadCustomers]);
  useEffect(() => {
    setShow(true);
  }, []);

  const removeCol =
    'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,itemCreatedAt,inactive,isgoing,ishost';
  const CustomerTable = JSON.parse(JSON.stringify(customeritemsByDate));
  CustomerTable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));

  // if (!loadCustomers || loading) return <LoadingComponent />;
  return (
    <>
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <LoadingComponent />
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !userStore.user?.isAdmin === true && <UnauthorizedMessage />}

      {userStore.user?.isAdmin === true && (
        <div className="large-table-screen">
          <div className="small-table-screen">
            <Segment>
              <Header
                clearing
                icon="list"
                size="huge"
                dividing
                as="h1"
                content="View Customers"
                sub
                color="grey"
              />
              {showText && (
                <DynamicTableFrontEnd
                  data={CustomerTable}
                  name={'CustomerTable'}
                  actiontype={'editdel'}
                />
              )}
            </Segment>
          </div>
        </div>
      )}
    </>
  );
};
export default observer(VaultMasterTable);
